export default __webpack_public_path__ + "static/media/bookmark.a0abcb8b.svg";